import { Component } from '@cms-max/medicare-api-sdk'
import { Alert } from '@cmsgov/design-system'
import { ContentLayout } from 'components/Layouts'
import { BackToPremiumsLink } from 'containers/Premiums/components/BackToPremiums'
import { BackToPremiumsBreadcrumb } from 'containers/Premiums/components/BackToPremiumsBreadcrumb'
import { useQueryParams } from 'hooks/useQueryParams'
import { useTranslation } from 'react-i18next'

export function MakeAPaymentErrorPage () {
  const { t } = useTranslation('makeAPaymentErrorPage')
  const queryParams = useQueryParams()
  const code = queryParams.get('code')

  const getAlertContent = () => {
    switch (code) {
      case 'paygov':
        return {
          heading: t('paygov.heading'),
          content: t('paygov.content')
        }
      default:
        return {
          heading: t('coreapi.heading'),
          content: t('coreapi.content')
        }
    }
  }

  const alertContent = getAlertContent()
  const { heading, content } = alertContent

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('heading')}
      width="wide"
      withPrintButton
      printComponent={Component.Premiums}
      nav={<BackToPremiumsBreadcrumb />}
    >
    <div className="ds-l-container">
      <h2 className="ds-text-heading--lg">{t('subHeading')}</h2>
      <div className="ds-u-measure--wide">
        <Alert variation="error" heading={heading}>
          {content}
        </Alert>
      </div>

      <div className="ds-u-margin-top--3">
        <BackToPremiumsLink />
      </div>
    </div>
    </ContentLayout>
  )
}
